import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SnackbarService, SnackbarConfig } from '../../core/services/snackbar.service';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent implements OnInit, OnDestroy {
  message: string = '';
  icon: string = '';
  visible = false;

  private timer: any;
  private sub!: Subscription;

  constructor(private snackbarService: SnackbarService) {}

  ngOnInit(): void {
    this.sub = this.snackbarService.snackbar$.subscribe((config: SnackbarConfig) => {
      this.show(config);
    });

    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.visible = false;
    }, 15000);
  }

  private show(config: SnackbarConfig) {
    this.message = config.message;
    this.icon = config.icon || '';
    this.visible = true;

    if (this.timer) clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      this.visible = false;
    }, config.duration ?? 3000);
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
